import React from 'react';
import RemoveItemsRow from "./RemoveItemsRow";
import LocalUrlMaker from "../lib/LocalUrlMaker";

export default function TableFoot({items, hideItem}) {
  return (<tfoot>
  <tr>
    <th className="empty"></th>
    {items.map(item => <th>
        <div className="more-details">
          <a className="button" href={LocalUrlMaker.prefixedPath(item.path)}>
            More Details</a>
        </div>
      </th>)}
  </tr>
  <RemoveItemsRow items={items} hideItem={hideItem}/>
  </tfoot>);
}
